import React, { useState, useEffect } from 'react';
import { Card, Alert } from 'react-bootstrap';
import { readContract } from '@wagmi/core';
import postConsensusContractABI from '../contracts/tgetherPostConsensus.json'; // Ensure the ABI is correct
import ReviewCard from './Items/ReviewCard.tsx';
import * as config from '../config.tsx';

const postConsensusContractAddress = process.env.REACT_APP_POSTS_CONSENSUS_CONTRACT_ADDRESS as `0x${string}`;

interface ReviewType {
  reviewId: number;
  member: string;
  content: string;
  consensus: number;
  consensusType: string;
  creds: number;
  afterConsensus: string;
}

function ReviewIdSearch({ value }: { value: string }) {
  const [review, setReview] = useState<ReviewType | null>(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!value || isNaN(Number(value))) {
      setError('Invalid Review ID provided.');
      setLoading(false);
      return;
    }

    setError(''); // Clear any previous errors
    fetchReview(Number(value));
  }, [value]);

  const fetchReview = async (reviewId: number) => {
    setLoading(true);

    try {
      const reviewData = await readContract(config.config, {
        address: postConsensusContractAddress,
        abi: postConsensusContractABI.abi,
        functionName: 'getReview',
        args: [reviewId],
      }) as {
        member: string;
        content: string;
        consensus: bigint;
        consensusType: string;
        creds: bigint;
        afterConsensus: boolean;
      };

      console.log('reviewData:', reviewData);

      if (reviewData && reviewData.member !== '0x0000000000000000000000000000000000000000') {
        setReview({
          reviewId: reviewId,
          member: reviewData.member,
          content: reviewData.content,
          consensus: Number(reviewData.consensus), // Convert `bigint` to `number`
          consensusType: reviewData.consensusType,
          creds: Number(reviewData.creds), // Convert `bigint` to `number`
          afterConsensus: reviewData.afterConsensus ? 'Yes' : 'No', // Convert boolean to 'Yes'/'No'
        });
      } else {
        setReview(null);
      }
    } catch (error) {
      console.error('Error fetching review:', error);
      setError('Failed to fetch review. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {error && <Alert variant="danger">{error}</Alert>}
      {loading ? (
        <div>Loading review...</div>
      ) : review ? (
        <ReviewCard review={review} />
      ) : (
        !error && <div>No review found with ID: {value}</div>
      )}
    </>
  );
}

export default ReviewIdSearch;
